import CmpMarkerInput from "./CmpMarkerInput";

export default CmpMarkerInput;